import styled from "styled-components";

import { StyledScrollableTableContent } from "app/pages/sales-intelligence/common-components/search-results-table";
import {
    HIGHLIGHT_ANIMATION_BACKGROUND_COLOR,
    HIGHLIGHT_ANIMATION_TIME,
} from "app/pages/sales-intelligence/constants/highlight-animation";

export const StyledScrollableTableContentWithHighlights = styled(StyledScrollableTableContent)`
    min-height: 0;
    overflow-y: hidden;

    .ant-table-body,
    .ant-table-tbody {
        .highlight-animation {
            transition: background-color ${HIGHLIGHT_ANIMATION_TIME}ms ease-in !important;
        }

        .highlight-column {
            background-color: ${HIGHLIGHT_ANIMATION_BACKGROUND_COLOR} !important;
        }
    }

    .ant-table-expanded-row-cell.ant-table-expanded-row-cell-fixed {
        height: auto;
    }
`;
